






























  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import { AppModule } from '@/store/modules/app';
import AssignConversationRequest from '@/models/Conversations/AssignConversationRequest';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';

@Component({
    name: 'BookingAssignConversation'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    agencyUsers: AgencyUserDto[];

    async assign(agencyUser: AgencyUserDto) {
        const request = new AssignConversationRequest();
        request.agencyUserId = agencyUser.id;
        await BookingDetailsModule.assignConversation(request);
    }


    get agencyUsersFiltered() {
      if (BookingDetailsModule.conversation && BookingDetailsModule.conversation.assignedToEntityId) {
        return this.agencyUsers.filter((agencyUser) => (
        agencyUser.id !== BookingDetailsModule.conversation.assignedToEntityId
        ));
      } else {
        return this.agencyUsers;
      }
    }

    getUserAvatarUrl(user: AgencyUserDto) {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + user.id + "/resized-100/" + user.avatar;
    }
}
